import React from "react"
import SiteContext from "../../context/site-context"
import { GetMenuTypePath } from "../../lib/site-functions"
import { Link } from "gatsby"
import './services.css';
export default function Services() {
  const myRef = React.useRef(null)
  const offsetY = myRef.current?.getBoundingClientRect().y

  const [inView, setInView] = React.useState(() => {
    return false
  })

  const { menuItemsState } = React.useContext(SiteContext)

  const [servicesState, servicesSetState] = React.useState(() => {
    return []
  })

  React.useEffect(() => {
    const companyItems = menuItemsState.companies.filter(
      item => item.showInServices === true
    )
    const serviceItems = menuItemsState.services.filter(
      item => item.showInServices === true
    )
    const otherItems = menuItemsState.others.filter(
      item => item.showInServices === true
    )

    servicesSetState([...companyItems, ...serviceItems, ...otherItems])
  }, [menuItemsState.loadedTime])

  React.useEffect(() => {
    if (inView === false) {
      if (offsetY < 350) {
        setInView(true)
      }
    }
  }, [offsetY])

  return (
    <div
      ref={myRef}
      className={
        "services-wrapper gray-bg hidden " +
        (inView ? "visible animated fadeIn" : "")
      }
      style={{minHeight: "490px"}}
    >
      <div className="push70" />

      <div className="container">
        <div className="text-center">
          <div className="suptitle-h1 color-scheme-defauult">
            комплексные, информационно-технические
          </div>
          <div className="title-h1 bold">Услуги для вашей организации</div>

          <div className="subtitle-h1">
            Равным образом консультация с широким активом позволяет оценить
            значение существенных финансовых и административных условий.
          </div>

          <div className="push10" />
        </div>

        <div className="row text-center zxc">
          {servicesState.map(item => (
            <ServiceItem
              key={item.id}
              Title={item.title}
              ImagePath={item.icon}
              Reference={
                "/infopages/" + GetMenuTypePath(item.menuType) + "/" + item.slug
              }
              inView={inView}
            />
          ))}
        </div>
      </div>

      <div className="push60" />
    </div>
  )
}

const ServiceItem = ({ ImagePath, Title, Reference, inView }) => {
  return (
    <div className="col-sm-6 col-md-3 d-inline-block asd">
      <div className={"element text-center relative hidden " + (inView ? "visible animated fadeInUp" : "")}>
        <Link to={Reference} className="absolute" />
        <div className="img-wrapper">
          <div className="table">
            <div className="table-cell text-center">
              <img
                src={
                  ImagePath === null
                    ? "/images/services/services-icon-1.png"
                    : ImagePath
                }
                alt={Title}
                width="90"
              />
            </div>
          </div>
        </div>
        <div className="element-content">
          <div className="title black bold f16">
            <div className="table">
              <div className="table-cell">{Title}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
